import { render, staticRenderFns } from "./packaging.vue?vue&type=template&id=78f6a3a0&"
import script from "./packaging.vue?vue&type=script&lang=js&"
export * from "./packaging.vue?vue&type=script&lang=js&"
import style0 from "./packaging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports